import { Axios } from '@/config/axios'

const state = {
}

const getters = {
}

const actions = {
    getDashboardData ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/dashboard?ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
